import api from '../../services/api';

const urlBase = '/veiculos';

export default {
  listar: (params = {}) =>
    api.get(urlBase, { params }),

  criar: data =>
    api.post(urlBase, data),

  atualizar: (veiculo_id, data) =>
    api.put(`${urlBase}/${veiculo_id}`, data),

  atualizarStatus: (veiculo_id, status) =>
    api.put(`${urlBase}/${veiculo_id}/status`, { status }),

  excluir: veiculo_id =>
    api.delete(`${urlBase}/${veiculo_id}`),

  buscarPorId: veiculo_id =>
    api.get(`${urlBase}/${veiculo_id}`).then(res => res.data),

  listarCarretasDisponiveis: () =>
    api.get(`${urlBase}/conjuntos/carretas-disponiveis`).then(res => res.data),

  buscarConjunto: (veiculo_id) =>
    api.get(`${urlBase}/${veiculo_id}/conjunto`).then(res => res.data),

  salvarConjunto: (veiculo_id, carreta_ids = []) =>
    api.put(`${urlBase}/${veiculo_id}/conjunto`, { carreta_ids }).then(res => res.data),
};
